type Env = { VITE_API_BASE_URL?: string };
const env = (import.meta as unknown as { env?: Env }).env;
export const API_BASE_URL: string = env?.VITE_API_BASE_URL ?? "https://timetraveller.colaunch360.com";

const toUrl = (path: string) => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalized}`;
};

export async function jsonFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(toUrl(path), {
    method: "GET",
    headers: { "Accept": "application/json" },
    ...init,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Request failed ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<T>;
}

export async function jsonPost<T, B extends object>(path: string, body: B, init?: RequestInit): Promise<T> {
  const res = await fetch(toUrl(path), {
    method: "POST",
    headers: { "Accept": "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(body),
    ...init,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Request failed ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<T>;
}

export async function multipartPost<T>(path: string, body: FormData, init?: RequestInit): Promise<T> {
  const res = await fetch(toUrl(path), {
    method: "POST",
    headers: { "Accept": "application/json" },
    body,
    ...init,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Request failed ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<T>;
}